import React from 'react'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { CustomTableHeaderCell } from './CustomTableHeaderCell'
import { CustomTableHeaderSelectCell } from './CustomTableHeaderSelectCell'
import { CustomTableHeaderCollapseCell } from './CustomTableHeaderCollapseCell'
import TableCell from '@mui/material/TableCell'
import { observer } from 'mobx-react-lite'
import { CustomTableStore, useCustomTableStore } from '../CustomTableStore'
import useCustomTableRenderLog from '../hooks/useCustomTableRenderLog'

export const CustomTableHead = observer(function CustomTableHead<RowData extends AnyObject, RowStore>() {
   useCustomTableRenderLog('CustomTableHead')
   const customTableStore = useCustomTableStore<CustomTableStore<RowData, RowStore>>()

   const styling = customTableStore.sp.styling || {}
   const hasActions = customTableStore.rowActions.length > 0
   return (
      <TableHead style={styling.headerStyle}>
         <TableRow style={styling.headerRowStyle}>
            <CustomTableHeaderSelectCell />
            <CustomTableHeaderCollapseCell />

            {customTableStore.sp.columns.map((column, index) => (
               <CustomTableHeaderCell key={index} column={column} index={index} />
            ))}

            {hasActions && <TableCell style={customTableStore.actionColumnHeaderStyle}>Actions</TableCell>}
         </TableRow>
      </TableHead>
   )
})
